export const replaceSessions = (arr) => {
    return { type: 'REPLACE_SESSIONS', payload: arr }
};

export const addSessions = (arr) => {
    return { type: 'ADD_SESSIONS', payload: arr }
};

export const updateSession = (obj) => {
    return { type: 'UPDATE_SESSION', payload: obj }
};
